import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { AuthenticationService } from '@core/auth/authentication.service';
import { HasPermissionDirective } from '@shared/directives/has-permission.directive';
import {ErrorService} from '../../../../../shared/services/error.service';
import {ZonasService} from './zonas.service';
import {Zona} from './zonas.interface';
import {PageHeaderComponent} from '../../../../../shared/components/common/page-header/page-header.component';
import {DeleteTrigger} from '../../../../../shared/components/ui/delete-trigger/delete-trigger';
import {SnackbarService} from '@shared/services/snackbar.service';
import {DataTable, Pagination, TableCellDirective, TableColumn} from '@shared/components/ui/list-components';

@Component({
  selector: 'app-zonas',
  imports: [
    HasPermissionDirective,
    PageHeaderComponent,
    DeleteTrigger,
    DataTable,
    Pagination,
    TableCellDirective,
  ],
  templateUrl: './zonas.html'
})
export class Zonas implements OnInit {
  readonly permissionAuth = inject(AuthenticationService);

  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private errorService = inject(ErrorService);
  private zonasService = inject(ZonasService);
  private snackbarService = inject(SnackbarService);

  zonas: Zona[] = [];
  loading = false;
  currentPage = 1;
  lastPage = 1;
  perPage = 15;
  total = 0;

  columns: TableColumn[] = [
    { key: 'nombre', header: 'Nombre' },
    { key: 'ciudad', header: 'Ciudad' },
    { key: 'departamento', header: 'Departamento' },
    { key: 'pais', header: 'País' },
    { key: 'acciones', header: 'Acciones' },
  ];

  ngOnInit(): void {
    this.getZonas();
  }

  getZonas(page: number = 1): void {
    this.loading = true;
    this.zonasService.index({page, per_page: this.perPage}).subscribe({
      next: (response) => {
        if (response.status) {
          this.zonas = response.data.data;
          this.currentPage = response.data.pagination.current_page;
          this.lastPage = response.data.pagination.last_page;
          this.total = response.data.pagination.total;
        }
      }, error: (error) => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.loading = false;
    });
  }

  onPageChange(page: number): void {
    this.getZonas(page);
  }

  onPerPageChange(perPage: number): void {
    this.perPage = perPage;
    this.currentPage = 1;
    this.getZonas();
  }

  create(): void {
    this.router.navigate(['new'], {relativeTo: this.route});
  }

  edit(id: number): void {
    this.router.navigate(['./', id], {relativeTo: this.route});
  }

  delete(id: number): void {
    this.zonasService.destroy(id).subscribe({
      next: (response) => {
        if (response.status) {
          this.snackbarService.showSnackBar('Zona eliminada correctamente');
          const page = this.zonas.length === 1 && this.currentPage > 1
            ? this.currentPage - 1
            : this.currentPage;
          this.getZonas(page);
        }
      },
      error: (error) => {
        this.errorService.handleError(error);
      }
    });
  }

  getCiudad(zona: any): string {
    if (!zona.direccion_completa) return '-';
    const parts = zona.direccion_completa.split(' / ');
    return parts[1] || '-';
  }

  getDepartamento(zona: any): string {
    if (!zona.direccion_completa) return '-';
    const parts = zona.direccion_completa.split(' / ');
    return parts[2] || '-';
  }

  getPais(zona: any): string {
    if (!zona.direccion_completa) return '-';
    const parts = zona.direccion_completa.split(' / ');
    return parts[3] || '-';
  }
}
